module.exports = __webpack_public_path__ + "img/fdca70e0c52d20adc768dae52640f2a7.jpg";